<template>
  <div>
    <vs-prompt
      id="fuel-consumption-common-dialog"
      :class="{ dialog__large: isLarge }"
      @cancel="cancel"
      @close="close"
      :color="AISEA_COLOR.BLUE"
      :active.sync="active"
      :title="title"
      :accept-text="acceptText"
      :cancel-text="cancelText"
      :is-valid="isValid"
      :buttons-hidden="true"
      ref="FuelConsumptionCommonDialog"
    >
      <div class="dialog-close-button-container">
        <div class="dialog-close-button" @click="close">
          <feather-icon
            icon="XIcon"
            class="p-3"
            svg-classes="w-6 h-6"
          ></feather-icon>
        </div>
      </div>
      <slot name="contents"></slot>

      <div v-if="showButtons" class="button-area flex items-cemter justify-end">
        <div class="button__gray mr-2" @click="cancel">
          <span>{{ cancelText }}</span>
        </div>
        <div class="button" @click="accept">
          <span>{{ acceptText }}</span>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { ColorMixin, DocumentMixin } from "@/mixins";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

const { mapActions, mapMutations, mapState } = createNamespacedHelpers(
  "fuelConsumption"
);

export default {
  mixins: [ColorMixin, DocumentMixin],
  components: { VuePerfectScrollbar },
  props: {
    accept: { type: Function, required: false },
    cancel: { type: Function, required: false },
    close: { type: Function, required: true },
    showDialog: { type: Boolean, required: true },
    title: { type: String, required: true },
    acceptText: { type: String, required: false },
    cancelText: { type: String, required: false },
    isValid: { type: Boolean, required: false },
    showButtons: { type: Boolean, required: false, default: true },
    isLarge: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      active: false,
    };
  },
  watch: {
    showDialog(val) {
      this.active = val;
    },
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.dialog__large {
  .vs-dialog {
    min-width: 90vw !important;
  }
}

#fuel-consumption-common-dialog {
  footer::before {
    background: transparent;
  }

  .dialog-title {
    color: $aisea-dark-gray;
    font-weight: 600;
  }

  .vs-dialog-cancel {
    display: none;
  }

  .dialog-close-button-container {
    position: relative;
  }

  .dialog-close-button {
    cursor: pointer;
    color: $aisea-dark-gray;
    position: absolute;
    right: 0;
    top: -56px;
    border-radius: 6px;
  }

  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 12px;
    min-width: 64px;
    width: fit-content;
    background-color: $aisea-blue;
    color: $aisea-white;
    border-radius: 6px;
    font-weight: 400;
    cursor: pointer;
    border: solid 1px $aisea-blue;
    white-space: nowrap;

    &__gray {
      @extend .button;
      background-color: $aisea-white;
      border: solid 1px $aisea-white;
      color: $aisea-dark-gray;
    }

    &__border {
      @extend .button;
      background-color: $aisea-pure-white;
      color: $aisea-blue;

      &__gray {
        @extend .button;
        background-color: $aisea-pure-white;
        border: solid 1px $aisea-gray;
        color: $aisea-gray;
      }
    }

    &__icon {
      padding: 6px;
    }
  }
}
</style>
